import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL as CFG_URL, SUPABASE_ANON_KEY as CFG_KEY } from "./supabaseConfig";

// ─── Connection keys: localStorage first, config file fallback ─────────
// Felix pastes keys once in the Profile tab → Connection section; they
// survive zip overwrites (which wipe src/supabaseConfig.js). The anon key
// is public-by-design (see supabaseConfig.js), so localStorage is fine.
const LS_URL = "ctd-supabase-url";
const LS_KEY = "ctd-supabase-key";

function lsGet(k) {
  try {
    return (localStorage.getItem(k) || "").trim();
  } catch {
    return "";
  }
}

const SUPABASE_URL = lsGet(LS_URL) || CFG_URL;
const SUPABASE_ANON_KEY = lsGet(LS_KEY) || CFG_KEY;

const isPlaceholder = (v) =>
  !v || typeof v !== "string" || v.includes("PASTE_YOUR");

// True when real keys exist (localStorage or config file). False = demo mode
// ("Still there?" confirmations stay on this device for this visit).
export const SUPABASE_READY = !isPlaceholder(SUPABASE_URL) && !isPlaceholder(SUPABASE_ANON_KEY);

// True when the active keys came from the in-app Connection section.
export const KEYS_FROM_APP = Boolean(lsGet(LS_URL) && lsGet(LS_KEY));

export const supabase = SUPABASE_READY ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY) : null;

// ─── In-app key management (Profile tab → Connection) ───────────────────
export function getSavedConnKeys() {
  return { url: lsGet(LS_URL), key: lsGet(LS_KEY) };
}

export function saveConnKeys(url, key) {
  try {
    localStorage.setItem(LS_URL, (url || "").trim());
    localStorage.setItem(LS_KEY, (key || "").trim());
  } catch {
    /* ignore */
  }
}
